import script from "./HrTabPanels.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTabPanels.vue?vue&type=script&setup=true&lang=js"

import "./HrTabPanels.vue?vue&type=style&index=0&id=8785ce9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8785ce9a"]])

export default __exports__
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanels});
